import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import S3 from "react-aws-s3";
import apis from '../../api';
import "./CompanyInfo.css";
import { Div, Form, FormGroup, Forms, Label } from './CompanyInfo.styles';
import InfoIcon from '../InfoIcon/InfoIcon';
import useInfo from '../hooks/useInfo';
import "../../utils/tooltip.css"
import { Tooltip } from 'primereact/tooltip';
import Video from '../Video/Video';
import uploadFileS3 from '../../services/uploadFileS3';
import fileToBase64 from '../../services/fileToBase64';
import { Link } from 'react-router-dom';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import useWindowDimensions from '../hooks/useDimensions';
import { SelectButton } from 'primereact/selectbutton';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CompanyInfo
Description : Formulario de registro y configuración de la empresa
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el forumlario desde cero.
29/10/2021 Santiago Coca Rojas Modificación - Se agragan más propiedades a la creación de la compañía
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo en cuenta los cambios realizados con PrimeReact
================================================================================ */

export default function CompanyInfo(props) {

    /*Propiedades del componente*/
    const [companyId, setCompanyId] = useState(-1);
    const [tipoContribuyente, setTipoContribuyente] = useState("");
    const [tipoDocumento, setTipoDocumento] = useState("");
    const [documento, setDocumento] = useState("");
    const [digitoVerificacion, setDigitoVerificacion] = useState("");
    const [nombreEmpresa, setNombreEmpresa] = useState("");
    const [nombre, setNombre] = useState("");
    const [otroNombre, setOtroNombre] = useState("");
    const [apellido, setApellido] = useState("");
    const [otroApellido, setOtroApellido] = useState("");
    const [arl, setArl] = useState("");
    // const [banco, setBanco] = useState("");
    // const [tipoCuenta, setTipoCuenta] = useState("");
    // const [cuenta, setCuenta] = useState("");
    const [celular, setCelular] = useState("");
    //const [sectorEconomico, setSectorEconomico] = useState("");
    const [frecuencia, setFrecuencia] = useState("");
    const [logoEmpresa, setLogoEmpresa] = useState("");
    const [cantidadEmpleados, setCantidadEmpleados] = useState("");
    const [firma, setFirma] = useState("");
    const [pais, setPais] = useState("");
    const [departamento, setDepartamento] = useState("");
    const [ciudad, setCiudad] = useState("");
    const [exonerado, setExonerado] = useState("");
    const [operador, setOperador] = useState("");
    const [arranque, setArranque] = useState("");
    const [direccion, setDireccion] = useState("");
    const [rut, setRut] = useState("");
    const [camaraComercio, setCamaraComercio] = useState("");
    const [correoFacturacion, setCorreoFacturacion] = useState("")
    const [loadPage, setLoadPage] = useState(false)
    const [files1, setFiles1] = useState([])
    const [files2, setFiles2] = useState([])
    const [files3, setFiles3] = useState([])
    const [retencion, setRetencion] = useState("")
    const [facturacion, setFacturacion] = useState('N')

    const [tipoContribuyenteFac, setTipoContribuyenteFac] = useState("");
    const [tipoDocumentoFac, setTipoDocumentoFac] = useState("");
    const [documentoFac, setDocumentoFac] = useState("");
    const [digitoVerificacionFac, setDigitoVerificacionFac] = useState("");
    const [nombreEmpresaFac, setNombreEmpresaFac] = useState("");
    const [nombreFac, setNombreFac] = useState("");
    const [otroNombreFac, setOtroNombreFac] = useState("");
    const [apellidoFac, setApellidoFac] = useState("");
    const [otroApellidoFac, setOtroApellidoFac] = useState("");
    const [celularFac, setCelularFac] = useState("");
    const [paisFac, setPaisFac] = useState("");
    const [departamentoFac, setDepartamentoFac] = useState("");
    const [ciudadFac, setCiudadFac] = useState("");
    const [direccionFac, setDireccionFac] = useState("");


    /*Listas de valores del componente*/
    const [listaTipoContribuyente, setListaTipoContribuyente] = useState([]);
    const [listaTipoDocumento, setListaTipoDocumento] = useState([]);
    const [listaArl, SetListaArl] = useState([]);
    // const [listaBancos, setListaBancos] = useState([]);
    // const [listaTipoCuenta, setListaTipoCuenta] = useState([]);
    //const [listaSectorEconomico, setListaSectorEconomico] = useState([]);
    const [listaFrecuencia, setListaFrecuencia] = useState([]);
    const [listaCantidadEmpleados, setListaCantidadEmpleados] = useState([]);
    const [listaPais, setListaPais] = useState([]);
    const [listaDepartamento, setListaDepartamento] = useState([]);
    const [listaCiudad, setListaCiudad] = useState([]);
    const [listaPaisFac, setListaPaisFac] = useState([]);
    const [listaDepartamentoFac, setListaDepartamentoFac] = useState([]);
    const [listaCiudadFac, setListaCiudadFac] = useState([]);
    const [listaExonerado, setListaExonerado] = useState([]);
    const [listaOperador, setListaOperador] = useState([]);
    const [listaArranque, setListaArranque] = useState([]);
    const [optionsListaPais, setOptionsListaPais] = useState([]);

    /*Mensajes informativos*/
    const { info } = useInfo("CompanyInfo");

    const [loading1, setLoading1] = useState(false);

    /*Constantes globales del componente*/
    const { width } = useWindowDimensions()
    const headers = { Authorization: localStorage.getItem("token") }
    // const  = { borderRadius: "10px" };
    const groupWidth = { width: "100%" };
    const cardStyle = {
        width: "100%", marginBottom: "1rem", justifyContent: "center",
        boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.06), 0px 7px 9px rgba(0, 0, 0, 0.12), 0px 20px 25px -8px rgba(0, 0, 0, 0.18)'
    }
    const fileUploadRef = useRef(null);
    const fileUploadRef2 = useRef(null);
    const fileUploadRef3 = useRef(null);

    const [isRut, setIsRut] = useState(false)

    const toast = useRef(null);

    const options = [
        { name: 'No', value: 'N' },
        { name: 'Si', value: 'S' }
    ]
    useEffect(() => {
        const getLists = async () => {
            await apis.getValueListCompany(headers).then(res => {
                let data = res.data;
                let tipoDoc = data["TIPO DE IDENTIDAD"]
                let arls = data["ARL"]
                // let bancos = data["LOV_CODE_BANK"]
                // let tipoC = data["TIPO_CUENTA"]
                //let sectores = data["LOV_SECTOR_ECONOMICO"]
                let freq = data["PERIODO"]
                let cantEmp = data["LOV_CANTIDAD_EMPLEADOS"]
                let paises = data["PAISES"]
                let exonerados = data["EXO_1607"]
                let operadores = data["CODIGO_OPERADOR"]
                let calendarios = data["CALENDAR"]
                let contribuyentes = data["TIPO_CONTRIBUYENTE"]

                let contenidoTipoDoc = []
                let contenidoArls = []
                // let contenidoBancos = []
                // let contenidoTipoC = []
                //let contenidoSectores = []
                let contenidoFreq = []
                let contenidoCantEmp = []
                let contenidoExonerados = []
                let contenidoOperadores = []
                let contenidoCalendarios = []
                let contenidoContribuyentes = []

                tipoDoc.forEach(element =>
                    contenidoTipoDoc.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                arls.forEach(element =>
                    contenidoArls.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                // bancos.forEach(element =>
                //     contenidoBancos.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                // )
                // tipoC.forEach(element =>
                //     contenidoTipoC.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                // )
                /*sectores.forEach(element => 
                    contenidoSectores.push({"value":''+element.detail_id+'',"label":''+element.description+''})
                )*/
                freq.forEach(element =>
                    contenidoFreq.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                cantEmp.forEach(element =>
                    contenidoCantEmp.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )

                exonerados.forEach(element =>
                    contenidoExonerados.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                operadores.forEach(element =>
                    contenidoOperadores.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )

                calendarios.forEach(element =>
                    contenidoCalendarios.push({ "value": '' + element.ID_CALENDAR + '', "label": '' + element.DETAIL + '' })
                )

                contribuyentes.forEach(element =>
                    contenidoContribuyentes.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                //setPaises(_pais, _departamento, paises);
                setOptionsListaPais(paises);
                setListaTipoDocumento(contenidoTipoDoc);
                SetListaArl(contenidoArls);
                // setListaBancos(contenidoBancos);
                // setListaTipoCuenta(contenidoTipoC);
                //setListaSectorEconomico(contenidoSectores);
                setListaFrecuencia(contenidoFreq);
                setListaCantidadEmpleados(contenidoCantEmp);
                setListaExonerado(contenidoExonerados);
                setListaOperador(contenidoOperadores);
                setListaArranque(contenidoCalendarios);
                setListaTipoContribuyente(contenidoContribuyentes);
            })
        }
        getLists()
    }, [])


    useEffect(() => {
        /*En caso de que la empresa ya exista, se carga su información en las propiedades del componente*/
        getCompany()
    }, [])

    useEffect(() => {
        /*Se cargan los datos en la listas de valores de país, departamento y ciudad*/
        setPaises()
    }, [pais, departamento, optionsListaPais])

    useEffect(() => {
        setPaisesFac()
    }, [paisFac, departamentoFac, optionsListaPais])

    // useEffect(async () => {
    //     console.log(info)
    // }, [])

    const getCompany = async () => {
        let _pais = ""
        let _departamento = ""
        if (localStorage.getItem('client') != '0') {
            await apis.getBusiness(localStorage.getItem('token'), headers).then(res => {
                if (res.data["COMPANY"] != []) {
                    let defaultData = res.data["COMPANY"][0]
                    let docType = defaultData["DOC_TYPE"].split("|")
                    let arl = defaultData["ARL"].split("|")
                    // let bank = defaultData["BANK"].split("|")
                    // let accountType = defaultData["ACCOUNT_TYPE"].split("|")
                    let frequency = defaultData["PERIODO"].split("|")
                    let country = defaultData["PAISES"].split("|")
                    _pais = country[0]
                    let department = defaultData["DEPARTAMENTO"].split("|")
                    _departamento = department[0]
                    let city = defaultData["CIUDADES"].split("|")
                    let exo = defaultData["EXO_1607"].split("|")
                    let opCod = defaultData["CODIGO_OPERADOR"].split("|")
                    let calendario = defaultData["CALENDAR"].split("|")
                    let address = defaultData["ADDRESS"]
                    let companyType = defaultData["TIPO_CONTRIBUYENTE"].split("|")
                    let firstName = defaultData["FIRST_NAME"]
                    let lastName1 = defaultData["LAST_NAME1"]
                    let lastName2 = defaultData["LAST_NAME2"]
                    let otherName = defaultData["OTHERS_NAME"]
                    let _correoFacturacion = defaultData["CORREO_FACTURACION"]
                    let _rut = defaultData["RUT"]
                    let _camaraComercio = defaultData["COMMERCE"]
                    let _retencion = defaultData["RETENTION"]
                    let _facturacion = defaultData["CLIENT_BILLING_ADIC"]
                    if (_facturacion === "S") {
                        let _datosFacturacion = defaultData["CLIENT_BILLING_DATA"]
                        let docTypeFac = _datosFacturacion["DOC_TYPE"].split("|")
                        let countryFac = _datosFacturacion["PAISES"].split("|")
                        let departmentFac = _datosFacturacion["DEPARTAMENTO"].split("|")
                        let cityFac = _datosFacturacion["CIUDADES"].split("|")
                        let addressFac = _datosFacturacion["ADDRESS"]
                        let companyTypeFac = _datosFacturacion["TIPO_CONTRIBUYENTE"].split("|")
                        let firstNameFac = _datosFacturacion["FIRST_NAME"]
                        let lastName1Fac = _datosFacturacion["LAST_NAME1"]
                        let lastName2Fac = _datosFacturacion["LAST_NAME2"]
                        let otherNameFac = _datosFacturacion["OTHERS_NAME"]
                        setTipoDocumentoFac({ "value": '' + docTypeFac[0] + '', "label": '' + docTypeFac[1] + '' })
                        setDocumentoFac(_datosFacturacion["DOC_NUMBER"])
                        setDigitoVerificacionFac(_datosFacturacion["DV"])
                        setNombreEmpresaFac(_datosFacturacion["COMPANY_NAME"])
                        setCelularFac(_datosFacturacion["PHONE"])
                        setPaisFac({ "value": '' + countryFac[0] + '', "label": '' + countryFac[1] + '' })
                        setDepartamentoFac({ "value": '' + departmentFac[0] + '', "label": '' + departmentFac[1] + '' })
                        setCiudadFac({ "value": '' + cityFac[0] + '', "label": '' + cityFac[1] + '' })
                        setTipoContribuyenteFac({ "value": '' + companyTypeFac[0] + '', "label": '' + companyTypeFac[1] + '' })
                        setNombreFac(firstNameFac)
                        setApellidoFac(lastName1Fac)
                        setOtroApellidoFac(lastName2Fac)
                        setOtroNombreFac(otherNameFac)
                        setDireccionFac(addressFac)
                    }
                    setCompanyId(defaultData["CLIENT"])
                    setTipoDocumento({ "value": '' + docType[0] + '', "label": '' + docType[1] + '' })
                    setDocumento(defaultData["DOC_NUMBER"])
                    setDigitoVerificacion(defaultData["DV"])
                    setNombreEmpresa(defaultData["COMPANY_NAME"])
                    setArl({ "value": '' + arl[0] + '', "label": '' + arl[1] + '' })
                    // setBanco({ "value": '' + bank[0] + '', "label": '' + bank[1] + '' })
                    // setTipoCuenta({ "value": '' + accountType[0] + '', "label": '' + accountType[1] + '' })
                    // setCuenta(defaultData["ACCOUNT_NUMBER"])
                    setFrecuencia({ "value": '' + frequency[0] + '', "label": '' + frequency[1] + '' })
                    setLogoEmpresa(defaultData["LOGO"])
                    setCelular(defaultData["PHONE"])
                    setCantidadEmpleados(defaultData["NUMBRE_EMPLOYEES"])
                    setFirma(defaultData["FIRM"])
                    setPais({ "value": '' + country[0] + '', "label": '' + country[1] + '' })
                    setDepartamento({ "value": '' + department[0] + '', "label": '' + department[1] + '' })
                    setCiudad({ "value": '' + city[0] + '', "label": '' + city[1] + '' })
                    setExonerado({ "value": '' + exo[0] + '', "label": '' + exo[1] + '' })
                    setOperador({ "value": '' + opCod[0] + '', "label": '' + opCod[1] + '' })
                    setArranque({ "value": '' + calendario[0] + '', "label": '' + calendario[1] + '' })
                    setTipoContribuyente({ "value": '' + companyType[0] + '', "label": '' + companyType[1] + '' })
                    setNombre(firstName)
                    setApellido(lastName1)
                    setOtroApellido(lastName2)
                    setOtroNombre(otherName)
                    setDireccion(address)
                    setRut(_rut)
                    setCamaraComercio(_camaraComercio)
                    setCorreoFacturacion(_correoFacturacion)
                    setFacturacion(_facturacion)
                    setRetencion(_retencion)
                    if (_rut) {
                        setIsRut(true)
                    }
                }
            })
        }
        setLoadPage(true)
    }

    async function setPaises() {
        /*Función encargada de car los datos en las lista de valores de país, departamento y ciudad*/
        let contenidoPaises = []
        let contenidoDepartamentos = []
        let contenidoCiudades = []

        let contenidoPaisesFac = []
        let contenidoDepartamentosFac = []
        let contenidoCiudadesFac = []
        optionsListaPais.forEach(element => {
            let deps = []
            if (element.DEPARTAMENTO) {
                let dep = element.DEPARTAMENTO
                dep.forEach(d => {
                    let cities = []
                    if (d.CIUDADES) {
                        let city = d.CIUDADES
                        city.forEach(c =>
                            cities.push({ "code": '' + c.detail_id + '', "cname": '' + c.description + '' })
                        )
                    }
                    deps.push({ "code": '' + d.detail_id + '', "name": '' + d.description + '', "cities": cities })
                })
            }
            contenidoPaises.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '', "states": deps })
            contenidoPaisesFac.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '', "states": deps })
        })
        setListaPais(contenidoPaises);
        setListaPaisFac(contenidoPaisesFac)
        try {
            let _pais = contenidoPaises.filter((p) => p.value === pais.value)
            if (_pais[0].states.length !== 0) {
                contenidoDepartamentos = _pais[0].states
            }
            if (contenidoDepartamentos.length !== 0) {
                let _departamento = contenidoDepartamentos.filter((d) => d.code === departamento.value)
                if (_departamento !== undefined && _departamento.length !== 0) {
                    if (_departamento[0].cities.length > 0) {
                        contenidoCiudades = _departamento[0].cities
                    }
                }
            }
            //setListaPais(contenidoPaises);
            setListaDepartamento(contenidoDepartamentos);
            setListaCiudad(contenidoCiudades);

            let _paisFac = contenidoPaisesFac.filter((p) => p.value === paisFac.value)
            if (_paisFac[0].states.length !== 0) {
                contenidoDepartamentosFac = _paisFac[0].states
            }
            if (contenidoDepartamentosFac.length !== 0) {
                let _departamentoFac = contenidoDepartamentosFac.filter((d) => d.code === departamentoFac.value)
                if (_departamentoFac !== undefined && _departamentoFac.length !== 0) {
                    if (_departamentoFac[0].cities.length > 0) {
                        contenidoCiudadesFac = _departamentoFac[0].cities
                    }
                }
            }
            //setListaPais(contenidoPaises);
            setListaDepartamentoFac(contenidoDepartamentosFac);
            setListaCiudadFac(contenidoCiudadesFac);
        } catch (err) {
            console.log("Wait")
        }
    }

    const setPaisesFac = async () => {
        let contenidoPaisesFac = []
        let contenidoDepartamentosFac = []
        let contenidoCiudadesFac = []
        optionsListaPais.forEach(element => {
            let deps = []
            if (element.DEPARTAMENTO) {
                let dep = element.DEPARTAMENTO
                dep.forEach(d => {
                    let cities = []
                    if (d.CIUDADES) {
                        let city = d.CIUDADES
                        city.forEach(c =>
                            cities.push({ "code": '' + c.detail_id + '', "cname": '' + c.description + '' })
                        )
                    }
                    deps.push({ "code": '' + d.detail_id + '', "name": '' + d.description + '', "cities": cities })
                })
            }
            contenidoPaisesFac.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '', "states": deps })
        })
        try {
            let _paisFac = contenidoPaisesFac.filter((p) => p.value === paisFac.value)
            if (_paisFac[0].states.length !== 0) {
                contenidoDepartamentosFac = _paisFac[0].states
            }
            if (contenidoDepartamentosFac.length !== 0) {
                let _departamentoFac = contenidoDepartamentosFac.filter((d) => d.code === departamentoFac.value)
                if (_departamentoFac !== undefined && _departamentoFac.length !== 0) {
                    if (_departamentoFac[0].cities.length > 0) {
                        contenidoCiudadesFac = _departamentoFac[0].cities
                    }
                }
            }
            //setListaPais(contenidoPaises);
            setListaDepartamentoFac(contenidoDepartamentosFac);
            setListaCiudadFac(contenidoCiudadesFac);
        } catch (err) {
            console.log("Wait")
        }
    }

    function validateForm() {
        /*Función que valida que los campos no sean nulos para poder realizar el proceso de enviar la información*/
        let validation = false
        if (tipoContribuyente && tipoContribuyente.label === "PERSONA NATURAL") {
            validation = tipoDocumento != null && documento != null && nombreEmpresa != null &&
                arl != null &&
                frecuencia != null && pais != null && departamento != null &&
                ciudad != null && exonerado != null && operador != null && celular != null &&
                direccion != null && apellido != null && (files2.length > 0 || rut) && isRut && retencion != null;
            // return tipoDocumento != null && documento != null && nombreEmpresa != null &&
            //     arl != null &&
            //     frecuencia != null && pais != null && departamento != null &&
            //     ciudad != null && exonerado != null && operador != null && celular != null &&
            //     direccion != null && apellido != null && (files2.length > 0 || rut) && isRut;
        }
        else {
            validation = tipoDocumento != null && documento != null && nombreEmpresa != null &&
                arl != null &&
                frecuencia != null && pais != null && departamento != null &&
                ciudad != null && exonerado != null && operador != null && celular != null && direccion != null && (files2.length > 0 || rut) && isRut && retencion != null;
            // return tipoDocumento != null && documento != null && nombreEmpresa != null &&
            //     arl != null &&
            //     frecuencia != null && pais != null && departamento != null &&
            //     ciudad != null && exonerado != null && operador != null && celular != null && direccion != null && (files2.length > 0 || rut) && isRut;
        }
        if (facturacion === 'S') {
            if (tipoContribuyenteFac && tipoContribuyente.label === "PERSONA NATURAL") {
                validation = validation && tipoDocumentoFac != null && documentoFac != null && nombreEmpresaFac != null &&
                    paisFac != null && departamentoFac != null && ciudadFac != null && celularFac != null &&
                    direccionFac != null && apellido != null;
            }
            else {
                validation = validation && tipoDocumentoFac != null && documentoFac != null && nombreEmpresaFac != null &&
                    paisFac != null && departamentoFac != null && ciudadFac != null && celularFac != null && direccionFac != null;
            }
        }

        return validation
    }

    function handleSubmit(event) {
        event.preventDefault();
    }

    const showConfirm = (name, process, page) => {
        /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
        toast.current.show({
            severity: 'success', sticky: true, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i className="pi pi-check-circle" style={{ fontSize: '3rem', color: "green" }}></i>
                        <p>Información empresa {name} {process} existosamente</p>
                    </div>
                    <div style={{ justifyContent: 'center' }} className="grid p-fluid">
                        <Link style={{ textDecoration: 'none' }} to={page}>
                            <Button type="button" label="Continuar" className="p-button-success" />
                        </Link>
                    </div>
                </div>
            )
        });
    }

    async function postBusinessInfo(proceso, ruta) {
        /*Función encargada de almacenar la información de la empresa por primera vez*/
        const _tipoContribuyente = tipoContribuyente.value
        const _tipoDocumento = tipoDocumento.value;
        const _documento = documento;
        const _nombreEmpresa = nombreEmpresa;
        const _arl = arl.value;
        // const _banco = banco.value;
        // const _tipoCuenta = tipoCuenta.value;
        // const _cuenta = cuenta;
        const _celular = celular;
        //const _sectorEconimico = sectorEconomico.value;
        const _frecuencia = frecuencia.value;
        // let _logoEmpresa = "";
        const _cantidadEmpleados = cantidadEmpleados.value;
        //let _firma = "";
        const _pais = pais.value;
        const _departamento = departamento.value;
        const _ciudad = ciudad.value;
        const _exonerado = exonerado.value;
        const _operador = operador.value;
        const _dv = digitoVerificacion
        const _arranque = arranque.value;
        const _direccion = direccion;
        const _nombre = nombre;
        const _apellido = apellido;
        const _otroNombre = otroNombre;
        const _otroApellido = otroApellido;
        const _correoFacturacion = correoFacturacion
        const _facturacion = facturacion
        const _retencion = retencion

        const _tipoContribuyenteFac = tipoContribuyenteFac.value
        const _tipoDocumentoFac = tipoDocumentoFac.value;
        const _documentoFac = documentoFac;
        const _nombreEmpresaFac = nombreEmpresaFac;
        const _celularFac = celularFac;
        const _paisFac = paisFac.value;
        const _departamentoFac = departamentoFac.value;
        const _ciudadFac = ciudadFac.value;
        const _direccionFac = direccionFac;
        const _nombreFac = nombreFac;
        const _apellidoFac = apellidoFac;
        const _otroNombreFac = otroNombreFac;
        const _otroApellidoFac = otroApellidoFac;
        const _dvFac = digitoVerificacionFac

        const companyInfo = {
            DOC_TYPE: _tipoDocumento,
            DOC_NUMBER: _documento,
            COMPANY_NAME: _nombreEmpresa,
            ARL: _arl,
            // BANK: _banco,
            // ACCOUNT_TYPE: _tipoCuenta,
            // ACCOUNT_NUMBER: _cuenta,
            PHONE: _celular,
            DV: _dv,
            PERIODO: _frecuencia,
            // LOGO: _logoEmpresa,
            NUMBRE_EMPLOYEES: _cantidadEmpleados,
            //FIRM: _firma,
            PAISES: _pais,
            DEPARTAMENTO: _departamento,
            CIUDADES: _ciudad,
            EXO_1607: _exonerado,
            CODIGO_OPERADOR: _operador,
            CALENDAR: _arranque,
            ADDRESS: _direccion,
            FIRST_NAME: _nombre,
            LAST_NAME1: _apellido,
            LAST_NAME2: _otroApellido,
            OTHERS_NAME: _otroNombre,
            TIPO_CONTRIBUYENTE: _tipoContribuyente,
            RETENTION: _retencion,
            CORREO_FACTURACION: _correoFacturacion,
            CLIENT_BILLING_ADIC: _facturacion,
            CLIENT_BILLING_DATA: {
                DOC_TYPE: _tipoDocumentoFac,
                DOC_NUMBER: _documentoFac,
                COMPANY_NAME: _nombreEmpresaFac,
                PHONE: _celularFac,
                DV: _dvFac,
                PAISES: _paisFac,
                DEPARTAMENTO: _departamentoFac,
                CIUDADES: _ciudadFac,
                ADDRESS: _direccionFac,
                FIRST_NAME: _nombreFac,
                LAST_NAME1: _apellidoFac,
                LAST_NAME2: _otroApellidoFac,
                OTHERS_NAME: _otroNombreFac,
                TIPO_CONTRIBUYENTE: _tipoContribuyenteFac,
            }
        }
        try {
            await apis.postBusiness(companyInfo, headers).then(res => {
                // setLoading1(false)
                localStorage.setItem("client", res.data.COMPANY[0].CLIENT)
                localStorage.setItem("entity", res.data.COMPANY[0].ENTITY)
                // localStorage.setItem('logo', res.data.COMPANY[0].LOGO)
            })
        } catch (err) {
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        try {
            putBusinessInfo(proceso, ruta)
            setLoading1(false)
            // showConfirm(nombre, "creada", "/ProcessDIAN")
        } catch (err) {
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function putBusinessInfo(proceso, ruta) {
        /*Función encargada de de almacenar la infrmación de la empresa, cada que la misma se edite*/
        const _companyID = localStorage.getItem('client');
        const _entity = localStorage.getItem('entity')
        const _tipoContribuyente = tipoContribuyente.value
        const _tipoDocumento = tipoDocumento.value;
        const _documento = documento;
        const _nombreEmpresa = nombreEmpresa;
        const _arl = arl.value;
        // const _banco = banco.value;
        // const _tipoCuenta = tipoCuenta.value;
        // const _cuenta = cuenta;
        const _celular = celular;
        //const _sectorEconimico = sectorEconomico.value;
        const _frecuencia = frecuencia.value;
        let _logoEmpresa = logoEmpresa;
        const _cantidadEmpleados = cantidadEmpleados.value;
        //let _firma = firma;
        const _pais = pais.value;
        const _departamento = departamento.value;
        const _ciudad = ciudad.value;
        const _exonerado = exonerado.value;
        const _operador = operador.value;
        const _dv = digitoVerificacion;
        const _direccion = direccion;
        const _nombre = nombre;
        const _apellido = apellido;
        const _otroNombre = otroNombre;
        const _otroApellido = otroApellido;
        const _correoFacturacion = correoFacturacion
        let _rut = rut
        let _camaraComercio = camaraComercio

        const _facturacion = facturacion
        const _retencion = retencion

        const _tipoContribuyenteFac = tipoContribuyenteFac.value
        const _tipoDocumentoFac = tipoDocumentoFac.value;
        const _documentoFac = documentoFac;
        const _nombreEmpresaFac = nombreEmpresaFac;
        const _celularFac = celularFac;
        const _paisFac = paisFac.value;
        const _departamentoFac = departamentoFac.value;
        const _ciudadFac = ciudadFac.value;
        const _direccionFac = direccionFac;
        const _nombreFac = nombreFac;
        const _apellidoFac = apellidoFac;
        const _otroNombreFac = otroNombreFac;
        const _otroApellidoFac = otroApellidoFac;
        const _dvFac = digitoVerificacionFac

        if (files1.length > 0) {
            console.log(files1)
            try {
                let _archivo = files1[0]
                _logoEmpresa = await uploadFileS3(_entity, _companyID, _archivo, "logo", "logo", "jpg", headers)

                localStorage.setItem('logo', _logoEmpresa)
            }
            catch (err) {
                setLoading1(false)
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            }
        }

        if (files2.length > 0) {
            try {
                let _archivo2 = files2[0]
                _rut = await uploadFileS3(_entity, _companyID, _archivo2, "documentos", "RUT", "pdf", headers)
                setRut(_rut)
            }
            catch (err) {
                setLoading1(false)
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            }
        }

        if (files3.length > 0) {
            try {
                let _archivo3 = files3[0]
                _camaraComercio = await uploadFileS3(_entity, _companyID, _archivo3, "documentos", "COMMERCE", "pdf", headers)
                setCamaraComercio(_camaraComercio)
            }
            catch (err) {
                setLoading1(false)
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            }
        }

        const companyInfo = {
            COMPANY: [{
                CLIENT: _companyID,
                ENTITY: _entity,
                DOC_TYPE: _tipoDocumento,
                DOC_NUMBER: _documento,
                COMPANY_NAME: _nombreEmpresa,
                ARL: _arl,
                // BANK: _banco,
                // ACCOUNT_TYPE: _tipoCuenta,
                // ACCOUNT_NUMBER: _cuenta,
                PHONE: _celular,
                DV: _dv,
                PERIODO: _frecuencia,
                LOGO: _logoEmpresa,
                NUMBRE_EMPLOYEES: _cantidadEmpleados,
                //FIRM: _firma,
                PAISES: _pais,
                DEPARTAMENTO: _departamento,
                CIUDADES: _ciudad,
                EXO_1607: _exonerado,
                CODIGO_OPERADOR: _operador,
                ADDRESS: _direccion,
                FIRST_NAME: _nombre,
                LAST_NAME1: _apellido,
                LAST_NAME2: _otroApellido,
                OTHERS_NAME: _otroNombre,
                TIPO_CONTRIBUYENTE: _tipoContribuyente,
                RETENTION: _retencion,
                CORREO_FACTURACION: _correoFacturacion,
                CLIENT_BILLING_ADIC: _facturacion,
                CLIENT_BILLING_DATA: {
                    DOC_TYPE: _tipoDocumentoFac,
                    DOC_NUMBER: _documentoFac,
                    COMPANY_NAME: _nombreEmpresaFac,
                    PHONE: _celularFac,
                    DV: _dvFac,
                    PAISES: _paisFac,
                    DEPARTAMENTO: _departamentoFac,
                    CIUDADES: _ciudadFac,
                    ADDRESS: _direccionFac,
                    FIRST_NAME: _nombreFac,
                    LAST_NAME1: _apellidoFac,
                    LAST_NAME2: _otroApellidoFac,
                    OTHERS_NAME: _otroNombreFac,
                    TIPO_CONTRIBUYENTE: _tipoContribuyenteFac,
                }
            }]
        }
        console.log(companyInfo)
        try {
            await apis.putBusiness(companyInfo, headers).then(async res => {
                setLoading1(false)
                showConfirm(res.data["COMPANY"][0].COMPANY_NAME, proceso, ruta)
            })
        } catch (err) {
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function action() {
        /*Valida si la empresa ya existe, con el objetivo de determinar cuál proceso ejecutar*/
        if (companyId == undefined || companyId == -1 || companyId == null) {
            postBusinessInfo("creada", "/ProcessDIAN");
        }
        else {
            putBusinessInfo("actualizada", "/Home");
        }
    }

    /*Footer del componente*/
    const cardFooter = <span>
        <Button label="Guardar" loading={loading1} style={{ marginTop: '-7rem' }} disabled={!validateForm()} onClick={() => { setLoading1(true); action() }} />
    </span>

    /*Renderizado del componente*/
    return (
        <div className="flex flex-wrap align-items-center justify-content-center card-container">
            <Form onSubmit={handleSubmit}>
                <Tooltip target=".info" className='indigo-tooltip ml-1' />
                <Toast ref={toast} style={{ backgroundColor: 'white' }} />
                <div className="flex flex-column align-items-center justify-content-center font-bold text-4xl mt-5">
                    <div className="flex flex-row align-items-center mb-4">
                        <span className="text-900">Datos empresa</span>
                        <Video header="Instructivo proceso configuración datos de la empresa" url={localStorage.getItem('COMPANYINFO_VIDEO')} />
                    </div>
                    <Label htmlFor="label" className='mb-4'>(*) Campos obligatorios</Label>
                </div>
                <SkeletonTable load={loadPage} width="80vw">
                    <div className='flex justify-content-center'>
                        <Tooltip target=".info" className='indigo-tooltip ml-1' />
                        <Forms>
                            <Card title="Datos básicos" style={cardStyle}>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Tipo contribuyente *</Label>
                                        <InfoIcon msg={info[0]}
                                            element={
                                                <Dropdown value={tipoContribuyente} autoFocus
                                                    className='dd'
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setTipoContribuyente({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaTipoContribuyente} placeholder={tipoContribuyente.label}
                                                    emptyMessage={"No hay tipos disponibles"}
                                                    filter showClear filterBy="label" />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Tipo documento *</Label>
                                        <InfoIcon msg={info[1]}
                                            element={
                                                <Dropdown value={tipoDocumento}
                                                    className='dd'
                                                    disabled={companyId != null && companyId != undefined && companyId != -1}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setTipoDocumento({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaTipoDocumento} placeholder={tipoDocumento.label}
                                                    emptyMessage={"No hay documentos disponibles"}
                                                    filter showClear filterBy="label" />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Número documento *</Label>
                                        <InfoIcon msg={info[2]}
                                            element={
                                                <InputText
                                                    className='dd'
                                                    maxLength={12}
                                                    id="label2"
                                                    type="text"
                                                    disabled={companyId != null && companyId != undefined && companyId != -1}
                                                    value={documento}
                                                    onChange={(e) => setDocumento(e.target.value)}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Dígito de verificación*</Label>
                                        <InfoIcon msg={info[3]}
                                            element={
                                                <InputText
                                                    style={{ width: "3rem" }}
                                                    id="label2"
                                                    type="text"
                                                    maxLength={1}
                                                    disabled={companyId != null && companyId != undefined && companyId != -1}
                                                    value={digitoVerificacion}
                                                    onChange={(e) => setDigitoVerificacion(e.target.value)}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">{(tipoContribuyente && tipoContribuyente.label === 'PERSONA NATURAL') ? "Primer nombre" : "Nombre empresa"} *</Label>
                                        <InfoIcon msg={info[4]}
                                            element={
                                                <InputText
                                                    className='dd'
                                                    id="label3"
                                                    type="text"
                                                    value={tipoContribuyente && tipoContribuyente.label === 'PERSONA NATURAL' ? nombre : nombreEmpresa}
                                                    onChange={(e) => {
                                                        if (tipoContribuyente && tipoContribuyente.label === 'PERSONA NATURAL') {
                                                            setNombre(e.target.value)
                                                        }
                                                        else {
                                                            setNombreEmpresa(e.target.value)
                                                        }
                                                    }}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    {(tipoContribuyente && tipoContribuyente.label === 'PERSONA NATURAL') &&
                                        <FormGroup>
                                            <Label htmlFor="label">Segundo nombre</Label>
                                            <InfoIcon msg={info[5]}
                                                element={
                                                    <InputText
                                                        className='dd'
                                                        maxLength={10}
                                                        id="label3"
                                                        type="text"
                                                        value={otroNombre}
                                                        onChange={(e) => setOtroNombre(e.target.value)}
                                                    />
                                                }
                                            />
                                        </FormGroup>
                                    }
                                </Div>
                                {(tipoContribuyente && (tipoContribuyente.label === 'PERSONA NATURAL')) &&
                                    <Div>
                                        <FormGroup>
                                            <Label htmlFor="label">Primer apellido *</Label>
                                            <InfoIcon msg={info[6]}
                                                element={
                                                    <InputText
                                                        className='dd'
                                                        id="label3"
                                                        type="text"
                                                        value={apellido}
                                                        onChange={(e) => setApellido(e.target.value)}
                                                    />
                                                }
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label htmlFor="label">Segundo apellido</Label>
                                            <InfoIcon msg={info[7]}
                                                element={
                                                    <InputText
                                                        className='dd'
                                                        maxLength={10}
                                                        id="label3"
                                                        type="text"
                                                        value={otroApellido}
                                                        onChange={(e) => setOtroApellido(e.target.value)}
                                                    />
                                                }
                                            />
                                        </FormGroup>
                                    </Div>
                                }
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Celular/teléfono *</Label>
                                        <InfoIcon msg={info[8]}
                                            element={
                                                <InputText
                                                    className='dd'
                                                    maxLength={10}
                                                    id="label3"
                                                    type="text"
                                                    value={celular}
                                                    onChange={(e) => setCelular(e.target.value)}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Pais *</Label>
                                        <InfoIcon msg={info[9]}
                                            element={
                                                <Dropdown value={pais} options={listaPais}
                                                    className='dd'
                                                    filter showClear filterBy="label"
                                                    placeholder={pais.label} emptyMessage={"No hay países disponibles"}
                                                    onChange={(e) => {
                                                        try {
                                                            let label = e.originalEvent.nativeEvent.target.textContent;
                                                            setPais({ "value": e.value, "label": label });
                                                        } catch (err) {
                                                            console.log("Wait")
                                                        }
                                                    }}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Departamento *</Label>
                                        <InfoIcon msg={info[10]}
                                            element={
                                                <Dropdown value={departamento} options={listaDepartamento}
                                                    className='dd'
                                                    filter showClear filterBy="name" emptyMessage={"No hay departamentos disponibles"}
                                                    onChange={(e) => {
                                                        try {
                                                            setDepartamento({ "value": e.value.code, "label": e.value.name });
                                                        } catch (err) {
                                                            console.log("Wait")
                                                        }
                                                    }}
                                                    placeholder={departamento.label} optionLabel='name'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Ciudad *</Label>
                                        <InfoIcon msg={info[11]}
                                            element={
                                                <Dropdown value={ciudad}
                                                    className='dd'
                                                    filter showClear filterBy="cname" emptyMessage={"No hay ciudades disponibles"}
                                                    onChange={(e) => {
                                                        try {
                                                            setCiudad({ "value": e.value.code, "label": e.value.cname })
                                                        } catch (err) {
                                                            console.log("Wait")
                                                        }
                                                    }}
                                                    options={listaCiudad} placeholder={ciudad.label} optionLabel="cname"
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label" >Dirección *</Label>
                                        <InfoIcon msg={info[12]}
                                            element={
                                                <InputText
                                                    className='dd'
                                                    id="label3"
                                                    type="text"
                                                    value={direccion}
                                                    onChange={(e) => setDireccion(e.target.value)}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    {facturacion !== 'S' && <FormGroup>
                                        <Label htmlFor="label" >Correo facturación *</Label>
                                        <InfoIcon msg={info[23]}
                                            element={
                                                <InputText
                                                    className='dd'
                                                    id="label7"
                                                    type="email"
                                                    value={correoFacturacion}
                                                    onChange={(e) => setCorreoFacturacion(e.target.value)}
                                                />
                                            }
                                        />
                                    </FormGroup>}
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label" >¿Facturación a otra empresa?</Label>
                                        <InfoIcon msg={info[24]}
                                            element={
                                                <SelectButton options={options} value={facturacion} optionLabel="name"
                                                    onChange={(e) => {
                                                        setFacturacion(e.value);
                                                        if (e.value === 'S') {
                                                            setRetencion("")
                                                        }
                                                    }} />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    {facturacion !== 'S' && <FormGroup>
                                        <Label htmlFor="label" >¿Es agente de retención? *</Label>
                                        <InfoIcon msg={info[24]}
                                            element={
                                                <SelectButton options={options} value={retencion} optionLabel="name"
                                                    onChange={(e) => setRetencion(e.value)} />
                                            }
                                        />
                                    </FormGroup>}
                                </Div>
                            </Card>
                            {facturacion === 'S' && <Card title="Datos empresa facturación" style={cardStyle}>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Tipo contribuyente *</Label>
                                        <InfoIcon msg={info[0]}
                                            element={
                                                <Dropdown value={tipoContribuyenteFac}
                                                    className='dd'
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setTipoContribuyenteFac({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaTipoContribuyente} placeholder={tipoContribuyenteFac.label}
                                                    emptyMessage={"No hay tipos disponibles"}
                                                    filter showClear filterBy="label" />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Tipo documento *</Label>
                                        <InfoIcon msg={info[1]}
                                            element={
                                                <Dropdown value={tipoDocumentoFac}
                                                    className='dd'
                                                    // disabled={companyId != null && companyId != undefined && companyId != -1}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setTipoDocumentoFac({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaTipoDocumento} placeholder={tipoDocumentoFac.label}
                                                    emptyMessage={"No hay documentos disponibles"}
                                                    filter showClear filterBy="label" />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Número documento *</Label>
                                        <InfoIcon msg={info[2]}
                                            element={
                                                <InputText
                                                    className='dd'
                                                    maxLength={12}
                                                    id="label2"
                                                    type="text"
                                                    // disabled={companyId != null && companyId != undefined && companyId != -1}
                                                    value={documentoFac}
                                                    onChange={(e) => setDocumentoFac(e.target.value)}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Dígito de verificación*</Label>
                                        <InfoIcon msg={info[3]}
                                            element={
                                                <InputText
                                                    style={{ width: "3rem" }}
                                                    id="label2"
                                                    type="text"
                                                    maxLength={1}
                                                    // disabled={companyId != null && companyId != undefined && companyId != -1}
                                                    value={digitoVerificacionFac}
                                                    onChange={(e) => setDigitoVerificacionFac(e.target.value)}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">{(tipoContribuyenteFac && tipoContribuyenteFac.label === 'PERSONA NATURAL') ? "Primer nombre" : "Nombre empresa"} *</Label>
                                        <InfoIcon msg={info[4]}
                                            element={
                                                <InputText
                                                    className='dd'
                                                    id="label3"
                                                    type="text"
                                                    value={tipoContribuyenteFac && tipoContribuyenteFac.label === 'PERSONA NATURAL' ? nombreFac : nombreEmpresaFac}
                                                    onChange={(e) => {
                                                        if (tipoContribuyenteFac && tipoContribuyenteFac.label === 'PERSONA NATURAL') {
                                                            setNombreFac(e.target.value)
                                                        }
                                                        else {
                                                            setNombreEmpresaFac(e.target.value)
                                                        }
                                                    }}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    {(tipoContribuyenteFac && tipoContribuyenteFac.label === 'PERSONA NATURAL') &&
                                        <FormGroup>
                                            <Label htmlFor="label">Segundo nombre</Label>
                                            <InfoIcon msg={info[5]}
                                                element={
                                                    <InputText
                                                        className='dd'
                                                        maxLength={10}
                                                        id="label3"
                                                        type="text"
                                                        value={otroNombreFac}
                                                        onChange={(e) => setOtroNombreFac(e.target.value)}
                                                    />
                                                }
                                            />
                                        </FormGroup>
                                    }
                                </Div>
                                {(tipoContribuyenteFac && (tipoContribuyenteFac.label === 'PERSONA NATURAL')) &&
                                    <Div>
                                        <FormGroup>
                                            <Label htmlFor="label">Primer apellido *</Label>
                                            <InfoIcon msg={info[6]}
                                                element={
                                                    <InputText
                                                        className='dd'
                                                        id="label3"
                                                        type="text"
                                                        value={apellidoFac}
                                                        onChange={(e) => setApellidoFac(e.target.value)}
                                                    />
                                                }
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label htmlFor="label">Segundo apellido</Label>
                                            <InfoIcon msg={info[7]}
                                                element={
                                                    <InputText
                                                        className='dd'
                                                        maxLength={10}
                                                        id="label3"
                                                        type="text"
                                                        value={otroApellidoFac}
                                                        onChange={(e) => setOtroApellidoFac(e.target.value)}
                                                    />
                                                }
                                            />
                                        </FormGroup>
                                    </Div>
                                }
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Celular/teléfono *</Label>
                                        <InfoIcon msg={info[8]}
                                            element={
                                                <InputText
                                                    className='dd'
                                                    maxLength={10}
                                                    id="label3"
                                                    type="text"
                                                    value={celularFac}
                                                    onChange={(e) => setCelularFac(e.target.value)}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Pais *</Label>
                                        <InfoIcon msg={info[9]}
                                            element={
                                                <Dropdown value={paisFac} options={listaPaisFac}
                                                    className='dd'
                                                    filter showClear filterBy="label"
                                                    placeholder={paisFac.label} emptyMessage={"No hay países disponibles"}
                                                    onChange={(e) => {
                                                        try {
                                                            let label = e.originalEvent.nativeEvent.target.textContent;
                                                            setPaisFac({ "value": e.value, "label": label });
                                                        } catch (err) {
                                                            console.log("Wait")
                                                        }
                                                    }}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Departamento *</Label>
                                        <InfoIcon msg={info[10]}
                                            element={
                                                <Dropdown value={departamentoFac} options={listaDepartamentoFac}
                                                    className='dd'
                                                    filter showClear filterBy="name" emptyMessage={"No hay departamentos disponibles"}
                                                    onChange={(e) => {
                                                        try {
                                                            setDepartamentoFac({ "value": e.value.code, "label": e.value.name });
                                                        } catch (err) {
                                                            console.log("Wait")
                                                        }
                                                    }}
                                                    placeholder={departamentoFac.label} optionLabel='name'
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Ciudad *</Label>
                                        <InfoIcon msg={info[11]}
                                            element={
                                                <Dropdown value={ciudadFac}
                                                    className='dd'
                                                    filter showClear filterBy="cname" emptyMessage={"No hay ciudades disponibles"}
                                                    onChange={(e) => {
                                                        try {
                                                            setCiudadFac({ "value": e.value.code, "label": e.value.cname })
                                                        } catch (err) {
                                                            console.log("Wait")
                                                        }
                                                    }}
                                                    options={listaCiudadFac} placeholder={ciudadFac.label} optionLabel="cname"
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label" >Dirección *</Label>
                                        <InfoIcon msg={info[12]}
                                            element={
                                                <InputText
                                                    className='dd'
                                                    id="label3"
                                                    type="text"
                                                    value={direccionFac}
                                                    onChange={(e) => setDireccionFac(e.target.value)}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label" >Correo facturación *</Label>
                                        <InfoIcon msg={info[23]}
                                            element={
                                                <InputText
                                                    className='dd'
                                                    id="label7"
                                                    type="email"
                                                    value={correoFacturacion}
                                                    onChange={(e) => setCorreoFacturacion(e.target.value)}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label" >¿Es agente de retención? *</Label>
                                        <InfoIcon msg={info[24]}
                                            element={
                                                <SelectButton options={options} value={retencion} optionLabel="name"
                                                    onChange={(e) => setRetencion(e.value)} />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                            </Card>}
                            <Card title="Datos de nómina" style={cardStyle}>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Frecuencia pagos *</Label>
                                        <InfoIcon msg={info[13]}
                                            element={
                                                <Dropdown value={frecuencia}
                                                    className='dd'
                                                    filter showClear filterBy="label" emptyMessage={"No hay frecuencias disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setFrecuencia({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaFrecuencia} placeholder={frecuencia.label}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    {/* <FormGroup>
                                <Label htmlFor="label">Número de empleados *</Label>
                                <Dropdown style={} value={cantidadEmpleados}
                                    filter showClear filterBy="label" emptyMessage={"No hay cantidades disponibles"}
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setCantidadEmpleados({ "value": e.value, "label": label })
                                    }}
                                    options={lista
                                        CantidadEmpleados} placeholder={cantidadEmpleados.label} />
                            </FormGroup> */}
                                    <FormGroup>
                                        <Label htmlFor="label">ARL *</Label>
                                        <InfoIcon msg={info[14]}
                                            element={
                                                <Dropdown value={arl}
                                                    className='dd'
                                                    filter showClear filterBy="label" emptyMessage={"No hay ARL disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setArl({ "value": e.value, "label": label });
                                                    }}
                                                    options={listaArl} placeholder={arl.label}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Código operador *</Label>
                                        <InfoIcon msg={info[15]}
                                            element={
                                                <Dropdown value={operador}
                                                    className='dd'
                                                    filter showClear filterBy="label" emptyMessage={"No hay operadores disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setOperador({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaOperador} placeholder={operador.label}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">¿Exonerado Ley 1607? *</Label>
                                        <InfoIcon msg={info[16]}
                                            element={
                                                <Dropdown value={exonerado}
                                                    className='dd'
                                                    filter showClear filterBy="label" emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setExonerado({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaExonerado} placeholder={exonerado.label} />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Mes de arranque *</Label>
                                        <InfoIcon msg={info[17]}
                                            element={
                                                <Dropdown value={arranque}
                                                    // className='w-50'
                                                    className='dd'
                                                    filter showClear filterBy="label" emptyMessage={"No hay meses disponibles"}
                                                    disabled={localStorage.getItem('client') !== '0'}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setArranque({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaArranque} placeholder={arranque.label}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                            </Card>
                            {/* <Card title="Datos bancarios" style={cardStyle}>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Banco *</Label>
                                        <InfoIcon msg={info[18]}
                                            element={
                                                <Dropdown value={banco}
                                                    className='dd'
                                                    filter showClear filterBy="label" emptyMessage={"No hay bancos disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setBanco({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaBancos} placeholder={banco.label}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Tipo cuenta *</Label>
                                        <InfoIcon msg={info[19]}
                                            element={
                                                <Dropdown value={tipoCuenta}
                                                    className='dd'
                                                    filter showClear filterBy="label" emptyMessage={"No hay tipos disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setTipoCuenta({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaTipoCuenta} placeholder={tipoCuenta.label}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Número cuenta *</Label>
                                        <div className='flex flex-start w-50'>
                                            <InfoIcon msg={info[20]}
                                                element={
                                                    <InputText
                                                        className='dd'
                                                        // className="flex-1"
                                                        maxLength={20}
                                                        id="label2"
                                                        type="text"
                                                        value={cuenta}
                                                        placeholder={cuenta}
                                                        onChange={(e) => setCuenta(e.target.value)}
                                                    />
                                                }
                                            />
                                        </div>
                                    </FormGroup>
                                </Div>
                            </Card> */}
                            <Card title="Adicionales" style={cardStyle}>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Agregar logo</Label>
                                        <InfoIcon msg={info[21]}
                                            element={
                                                <FileUpload mode="basic" name="demo[]" ref={fileUploadRef} accept="image/*" maxFileSize={2000000} chooseLabel="Seleccionar" onValidationFail={() => {
                                                    toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Error al subir el archivo. Supera el tamaño máximo permitido (2 MB)', sticky: true });
                                                }} onClear={() => setFiles1([])}
                                                    onSelect={(e) => setFiles1(e.files)}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">RUT*</Label>
                                        <InfoIcon msg={info[22]}
                                            element={
                                                <div className="flex flex-row">
                                                    <FileUpload mode="basic" name="demo[]" ref={fileUploadRef2} accept="application/pdf" maxFileSize={2000000} chooseLabel={rut ? "RUT.pdf" : "Subir"} onValidationFail={() => {
                                                        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Error al subir el archivo. Supera el tamaño máximo permitido (2 MB)', sticky: true });
                                                    }} onClear={() => { setFiles2([]); setIsRut(false) }}
                                                        onSelect={(e) => { setFiles2(e.files); setIsRut(true) }}
                                                    />
                                                    &nbsp;
                                                    {rut && <Button label={width > 426 ? "Descargar" : ""} icon="pi pi-download" onClick={() => window.location.href = rut} />}
                                                </div>
                                            }
                                        />
                                    </FormGroup>
                                    {/* <FormGroup>
                        <Label htmlFor="label">Agregar firma certificada</Label>
                        <FileUpload mode="basic" name="demo[]" ref={fileUploadRef2} accept="image/*" maxFileSize={1000000} auto chooseLabel="Seleccionar"/>
                    </FormGroup> */}
                                </Div>
                                <Div>
                                    <FormGroup style={{ display: width < 962 && 'none' }}>
                                        <Label htmlFor="label" style={{ display: 'none' }}>Cámara de comercio</Label>
                                        <Button label={width > 426 ? "Descargar" : ""} style={{ display: 'none' }} icon="pi pi-download" />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Cámara de comercio</Label>
                                        <InfoIcon msg={info[23]}
                                            element={
                                                <div className="flex flex-row">
                                                    <FileUpload mode="basic" name="demo[]" ref={fileUploadRef3} accept="application/pdf" maxFileSize={2000000} chooseLabel={camaraComercio ? (width > 398 ? "COMMERCE.pdf" : "CC.pdf") : "Subir"}
                                                        onValidationFail={() => {
                                                            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Error al subir el archivo. Supera el tamaño máximo permitido (2 MB)', sticky: true });
                                                        }} onClear={() => setFiles3([])}
                                                        onSelect={(e) => setFiles3(e.files)}
                                                    />
                                                    &nbsp;
                                                    {camaraComercio && <Button label={width > 536 ? "Descargar" : ""} icon="pi pi-download" onClick={() => window.location.href = camaraComercio} />}
                                                </div>
                                            }
                                        />
                                    </FormGroup>
                                </Div>
                            </Card>
                            <div className='mt-6'>
                                <Button label="Guardar" loading={loading1} style={{ marginTop: '-7rem' }} disabled={!validateForm()} onClick={() => { setLoading1(true); action() }} />
                            </div>
                        </Forms>
                    </div>
                </SkeletonTable>
            </Form>
        </div >
    );
}